export default store => (store ? store.state.appUser : null);
